import { toast } from '@cincoders/cinnamon';

const UNAUTHORIZED = 401;
const FORBIDDEN = 403;
const NOT_FOUND = 404;
const INTERNAL_SERVER_ERROR = 500;

export { UNAUTHORIZED, FORBIDDEN, NOT_FOUND, INTERNAL_SERVER_ERROR };

export function showError(status?: number): string | number {
  switch (status) {
    case UNAUTHORIZED:
      return toast.error('A solicitação não foi realizado pois as credenciais de autenticação não são válidas', {
        position: 'top-right',
      });
    case FORBIDDEN:
      return toast.error('Você não tem permissão de acesso', {
        position: 'top-right',
      });
    case NOT_FOUND:
      return toast.error('Erro ao se comunicar com o servidor, tente novamente mais tarde', {
        position: 'top-right',
      });
    case INTERNAL_SERVER_ERROR:
      return toast.error(
        'Erro ao consultar os dados, tente novamente mais tarde. ' +
          'Em caso de persistência, entre em contato com o Helpdesk: helpdesk@cin.ufpe.br',
        {
          position: 'top-right',
        },
      );
    default:
      return toast.error(
        'Houve um erro inesperado, tente novamente mais tarde. ' +
          'Em caso de persistência, entre em contato com o Helpdesk: helpdesk@cin.ufpe.br',
        { position: 'top-right' },
      );
  }
}
